import React from 'react';
import { Clock, Zap, Shield, Star, CheckCircle, Wrench } from 'lucide-react';

const features = [
  { icon: Star, title: 'Simple Operation', desc: 'One-touch presets make freeze drying easy for everyone' },
  { icon: CheckCircle, title: 'Meeting Canadian and American Safety Standards', desc: 'Certified for safe, reliable home use' },
  { icon: Zap, title: 'Energy Efficient', desc: 'Smart power management keeps electricity costs low' },
  { icon: Wrench, title: 'Built to Last', desc: 'Durable construction materials, modern design, and customizable accessories' }
];

export const FeaturesSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0a0203] mb-4">
            Why Choose HomeLyph?
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Built different. Designed for home use with industrial-grade reliability.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 stagger-children">
          {features.map((f, i) => (
            <div key={i} className="text-center p-8 rounded-2xl bg-[#f0f4f8] card-hover">
              <div className="w-16 h-16 mx-auto bg-[#90c9e0] rounded-2xl flex items-center justify-center mb-6">
                <f.icon className="h-8 w-8 text-[#003456]" />
              </div>
              <h3 className="text-xl font-semibold text-[#0a0203] mb-2">{f.title}</h3>
              <p className="text-gray-600">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
